Customer.Dashboard ||= {}

class Customer.Dashboard.WelcomeView extends Backbone.View
  template: JST["backbone/templates/customer/dashboard/welcome"]

  render: ->
    @$el.html(@template())
    @

  onSelectTab: (dashboard) ->
    dashboard.selectedFilter = undefined
    dashboard.history.clearState().go()
    dashboard.filterListView.renderFilters()
    dashboard.showFilters(true)

  tabName: ->
    "Welcome"

  tabId: ->
    "Welcome"

  uniqueId: ->
    "Welcome"

  iconSelector: ->
    ""

  currentScrollPosition: () ->
    # nothing to do

  scrollTo: (position) ->
    # nothing to do
